import { useState } from "react"
import { Divider, IconButton, ListItemText, ListSubheader, Menu, MenuItem, Tooltip } from "@mui/material"
import HelpOutlineIcon from "@mui/icons-material/HelpOutlineOutlined"
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined"

import { WW_BLUE } from "@/theme/tokens"

import { useTours } from "./TourProvider.jsx"
import TourList from "./TourList.jsx"

const MANUAL_URL = "/manuals/METEO_TRACKER_User_Manual.html"

export default function HelpMenu() {
  const { tours, completed, startTour } = useTours()
  const [anchorEl, setAnchorEl] = useState(null)
  const close = () => setAnchorEl(null)

  return (
    <>
      <Tooltip title="Help & tutorials">
        <IconButton
          data-tour="help-button"
          aria-label="Help and tutorials"
          aria-haspopup="menu"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ color: WW_BLUE }}
        >
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { width: 340 } } }}
      >
        <ListSubheader sx={{ lineHeight: "32px", color: WW_BLUE, fontWeight: 700 }}>
          Tutorials
        </ListSubheader>
        <TourList
          dense
          tours={tours}
          completed={completed}
          onStart={(id) => {
            close()
            startTour(id)
          }}
        />
        <Divider />
        <MenuItem component="a" href={MANUAL_URL} target="_blank" rel="noopener noreferrer" onClick={close}>
          <MenuBookOutlinedIcon fontSize="small" sx={{ color: WW_BLUE, mr: 1.5 }} />
          <ListItemText
            primary="User Manual"
            slotProps={{ primary: { sx: { fontSize: 14, color: WW_BLUE, fontWeight: 500 } } }}
          />
        </MenuItem>
      </Menu>
    </>
  )
}
